import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {KongService} from '../kong.service';
import {ConfService} from '../conf.service';

@Component({
  selector: 'app-learn',
  templateUrl: './learn.component.html',
  styleUrls: ['./learn.component.scss']
})
export class LearnComponent implements OnInit {

  height = 200;
  width = 340;
  startSeconds = 0;
  endSeconds = 0;
  suggestedQuality = 'highres';
  videoId = 'sEYhnVzgrsw';
  title = 'An introduction to navigate within apiplatform.io';
  @Input() videos: any;
  route: any;
  videosData: any;
  path: string;
  constructor(private location: Location,
              private router: Router,
              private _route: ActivatedRoute,
              private kong: KongService,
              private confPost: ConfService) { }

  getLearningVideoProperties(routePath) {
    this.confPost.getLearningVideos({'router': routePath}).subscribe(data => {
      if (data !== null && data !== undefined) {
        this.videosData = data.body[0];
        if (this.videosData !== undefined && this.videosData.videos !== undefined && this.videosData.videos !== null) {
          this.videos = this.videosData.videos;
        } else {
          this.videos = [
            {
              'videoId': this.videoId,
              'title': this.title
            }
          ];
        }
      } else {
        this.videos = [
          {
            'videoId': this.videoId,
            'title': this.title
          }
        ];
      }
    });

  }
  async ngOnInit() {
    this.path = this.router.url;
      await this.getLearningVideoProperties(this.path);
  }



}
